import React, { useEffect, useState } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./components/pages/LoginPage";
import ProductAdminPage from "./components/pages/ProductAdminPage";
import ProductsPage from "./components/pages/ProductsPage";
import CartPage from "./components/pages/CartPage";
import ProductManagment from "./components/pages/ProductManagment";
import UserProfilePage from "./components/pages/UserProfilePage"; // Importa la página de perfil
import AdminLayout from "./components/layouts/AdminLayout";
import UserLayout from "./components/layouts/UserLayout";
import { CartProvider } from "./contexts/CartContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SearchProvider } from "./contexts/SearchContext";
import RegisterPage from "./components/pages/RegisterPage";
import '../src/components/pages/style/App.css';
import ValidatePage from "./components/pages/ValidatePage";
import ForgotPasswordPage from "./components/pages/ForgotPasswordPage";
import ResetPasswordPage from "./components/pages/ResetPasswordPage";

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authToken, setAuthToken] = useState<string | null>(null);
  const [userRole, setUserRole] = useState<string | null>(null);
  const [authLoaded, setAuthLoaded] = useState(false);

  useEffect(() => {
    const storedToken = sessionStorage.getItem("authToken");
    const storedRole = sessionStorage.getItem("userRole");

    if (storedToken && storedRole) {
      setAuthToken(storedToken);
      setUserRole(storedRole);
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }

    setAuthLoaded(true);
  }, []);

  const handleLogin = (token: string, role: string) => {
    if (!token) {
      return;
    }

    setAuthToken(token);
    setUserRole(role);
    setIsAuthenticated(true);

    sessionStorage.setItem("authToken", token);
    sessionStorage.setItem("userRole", role);
  };

  const handleLogout = () => {
    setAuthToken(null);
    setUserRole(null);
    setIsAuthenticated(false);

    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("userRole");
  };

  if (!authLoaded) {
    return <div>Cargando autenticación...</div>;
  }

  return (
    <SearchProvider>
      <CartProvider>
        <Router>
          <Routes>
           <Route path="/user/validate/:token" element={<ValidatePage />} />
            <Route
              path="/login"
              element={<LoginPage onLogin={handleLogin} />}
            />
            <Route path="user/password/forgot" element={<ForgotPasswordPage />} />
            <Route path="user/password/reset" element={<ResetPasswordPage />} />
            {isAuthenticated && userRole === "admin" && (
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<ProductAdminPage />} />
                <Route
                  path="/admin/product-management"
                  element={<ProductManagment />}
                />
              </Route>
            )}

            {isAuthenticated && userRole !== "admin" && (
              <Route
                path="/"
                element={
                  <UserLayout
                    isAuthenticated={isAuthenticated}
                    handleLogout={handleLogout}
                    userName="NombreUsuario"
                  />
                }
              >
                <Route path="products" element={<ProductsPage />} />
                <Route path="cart" element={<CartPage />} />
                <Route path="profile" element={<UserProfilePage />} />
              </Route>
            )}
            <Route
              path="*"
              element={
                isAuthenticated && authToken ? (
                  <Navigate
                    to={userRole === "admin" ? "/admin" : "/products"}
                    replace
                  />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route path="/register" element={<RegisterPage />} />
          </Routes>

          <ToastContainer />
        </Router>
      </CartProvider>
    </SearchProvider>
  );
};

export default App;
